<div class="card screen-container">
  <div class="card-body p-4">
    <!-- Tabs -->
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item">
        <a class="nav-link" role="tab" (click)="activeTab = 1" [ngClass]="{'active': activeTab === 1}">Válvulas</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" role="tab" (click)="activeTab = 2" [ngClass]="{'active': activeTab === 2}">{{_appService.CoreCommonLiterals.Alarms}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" role="tab" (click)="activeTab = 3" [ngClass]="{'active': activeTab === 3}">{{_appService.CoreCommonLiterals.Devices}}</a>
      </li>
    </ul>

    <div class="tab-content" id="myTabContent">
      <div class="report-summary d-flex align-items-center justify-content-between pr-0">
        <div class="summary-left">
          <span class="muted">{{_appService.CoreCommonLiterals.MultiSelect_All_Male}}</span>
          <span class="count">({{ getTotalItemsCount() }})</span>
          <span class="separator">|</span>
          <span class="muted">Seleccionados</span>
          <span class="count">({{ getSelectedItemsCount() }})</span>
          <span class="separator">|</span>
          <button type="button" class="btn btn-secondary" (click)="clearCurrentTabSelection()" [disabled]="getSelectedItemsCount() === 0" tooltip="{{_appService.CoreCommonLiterals.ButtonClean}}">
            <i class="fa-solid fa-trash mr-1"></i>
          </button>
          <span class="separator">|</span>
          <div class="btn-group" dropdown [isDisabled]="getSelectedItemsCount() === 0">
            <button type="button" class="btn btn-primary dropdown-toggle" dropdownToggle [disabled]="getSelectedItemsCount() === 0">
              {{apolusService.literals.Actions}} <span class="caret"></span>
            </button>
            <ul *dropdownMenu class="dropdown-menu" role="menu">
              <li role="menuitem" *ngFor="let action of getCurrentTabMassActions()" style="cursor: pointer;">
                <a class="dropdown-item" (click)="initiateMassAction(action)">
                  <i *ngIf="action.icon" [class]="action.icon + ' ' + action.iconClass + ' mr-2'"></i>
                  {{action.label}}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="summary-actions d-flex gap-2">
          <button type="button" class="btn btn-primary" (click)="onLoadCurrentTabList()">
            <i class="fa-solid fa-upload mr-1"></i>
            Cargar Lista
          </button>
          <button type="button" class="btn btn-primary ml-2" (click)="addNewDevices()" *ngIf="activeTab === 3">
            <i class="fa-solid fa-plus mr-1"></i>
            Añadir nuevos
          </button>
        </div>
      </div>

      <div class="d-flex row no-gutters filter-section py-3">
        <div class="col-12">
          <div class="d-flex flex-row align-items-end gap-3 filter-row">
            <div class="form-group flex-container">
              <label for="search-text">{{_appService.CoreCommonLiterals.ButtonSearch}}</label>
              <i class="fa fa-search" *ngIf="!searchText"></i>
              <input id="search-text" type="text" class="form-control"
                [placeholder]="_appService.CoreCommonLiterals.ButtonSearch" 
                [(ngModel)]="searchText" 
                name="searchText"
                (input)="search($event)" 
                #inputElement 
                customFocus>
              <span class="input-group-append" *ngIf="searchText">
                <button id="table-preferences" class="btn btn-default btn-secondary" type="button" (click)="searchText = ''; search($event)"><i class="fa fa-times"></i></button>
              </span>
            </div>
            <div class="form-group flex-container">
              <custom-select
                [bordered]="true"
                [(ngModel)]="sector"
                [labelText]="gearAppService.GearCommonLiterals.Sector"
                name="sector"
                id="sector"
                #sectorModel="ngModel"
                [(sourceList)]="sectorList"
                required>
              </custom-select>
            </div>
            <div class="form-group flex-container">
              <custom-select
                [bordered]="true"
                [(ngModel)]="locality"
                [labelText]="apolusService.literals.Locality"
                name="locality"
                id="locality"
                #localityModel="ngModel"
                [(sourceList)]="localityList"
                required>
              </custom-select>
            </div>
            <div class="form-group flex-container">
              <custom-select
                [bordered]="true"
                [(ngModel)]="address"
                [labelText]="_appService.CoreCommonLiterals.Address"
                name="address"
                id="address"
                #addressModel="ngModel"
                [(sourceList)]="addressList"
                required>
              </custom-select>
            </div>
            <div class="form-group flex-container">
              <custom-select
                [bordered]="true"
                [(ngModel)]="streetNumber"
                [labelText]="_appService.CoreCommonLiterals.StreetNumber"
                name="streetNumber"
                id="streetNumber"
                #streetNumberModel="ngModel"
                [(sourceList)]="streetNumberList"
                required>
              </custom-select>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade mt-3" [ngClass]="{'active show': activeTab === 1}">
        <app-data-table
          [items]="endpoints"
          [selectedItems]="selectedEndpoints"
          [selectAll]="selectAllEndpoint"
          [columnConfig]="endpointColumns"
          [tableConfig]="endpointTableConfig"
          [currentPage]="currentPage"
          [itemsPerPage]="itemsPerPage"
          [itemsPerPageOptions]="itemsPerPageOptions"
          (selectAllChange)="toggleSelectAllEndpoint($event)"
          (itemSelectionChange)="updateEndpointSelection($event)"
          (pageChange)="onPageChange($event)"
          (itemsPerPageChange)="onItemsPerPageChange()"
          (loadList)="onLoadEndpointList()"
        ></app-data-table>
      </div>

      <div class="tab-pane fade mt-3" [ngClass]="{'active show': activeTab === 2}">
        <app-data-table
          [items]="alarmas"
          [selectedItems]="selectedAlarmas"
          [selectAll]="selectAllAlarmas"
          [columnConfig]="alarmaColumns"
          [tableConfig]="alarmaTableConfig"
          [currentPage]="currentPage"
          [itemsPerPage]="itemsPerPage"
          [itemsPerPageOptions]="itemsPerPageOptions"
          (selectAllChange)="toggleSelectAllAlarmas($event)"
          (itemSelectionChange)="updateAlarmaSelection($event)"
          (pageChange)="onPageChange($event)"
          (itemsPerPageChange)="onItemsPerPageChange()"
          (loadList)="onLoadAlarmaList()"
        ></app-data-table>
      </div>

      <div class="tab-pane fade mt-3" [ngClass]="{'active show': activeTab === 3}">
        <app-data-table
          [items]="devices"
          [selectedItems]="selectedDevices"
          [selectAll]="selectAllDevice"
          [columnConfig]="deviceColumns"
          [tableConfig]="deviceTableConfig"
          [currentPage]="currentPage"
          [itemsPerPage]="itemsPerPage"
          [itemsPerPageOptions]="itemsPerPageOptions"
          (selectAllChange)="toggleSelectAllDevice($event)"
          (itemSelectionChange)="updateDeviceSelection($event)"
          (pageChange)="onPageChange($event)"
          (itemsPerPageChange)="onItemsPerPageChange()"
          (loadList)="onLoadDeviceList()"
        ></app-data-table>
      </div>
    </div>
  </div>
</div>

<modal
    #actionConfirmModal
    id="actionConfirmModal"
    [submitButtonText]="_appService?.CoreCommonLiterals?.ButtonSave"
    (onSubmit)="executeMassAction(pendingMassAction!)"
    (onCancel)="cancelMassAction()"
    [cancelButtonText]="_appService?.CoreCommonLiterals?.ButtonCancel"
>
    <modal-header>Confirmar acción masiva</modal-header>
    <modal-content>
        <p>{{pendingMassAction?.confirmMessage || '¿Estás seguro de que deseas realizar esta acción?'}}</p>
        <p *ngIf="pendingMassAction?.confirmIcon">
          <span>Esta acción afectará a {{getSelectedItemsCount()}} elementos.</span>
        </p>
    </modal-content>
</modal>

<app-modal-batch-devices #modalBatchDevices (devicesLoaded)="onDevicesLoaded($event)"></app-modal-batch-devices>